module.exports = __webpack_public_path__ + "img/bg_village.37b7de87.jpg";